export const messages = {
    "wr-dashboard.search.input.hint": "搜尋",
    "wr-dashboard.search.label.breadcrumb": "搜尋結果",
    "wr-dashboard.search.message.empty": "沒有任何項目符合您的搜尋",
    "wr-dashboard.side-bar.selected.title:plural": "已選擇 {count} 個項目 | 已選擇 {count} 個項目",
    "wr-dashboard.side-bar.backup-type.disk": "磁碟",
    "wr-dashboard.side-bar.backup-type.file": "檔案",
    "wr-dashboard.side-bar.backup-type.notarized": "已公證的檔案和資料夾",
    "wr-dashboard.side-bar.backup-type.exchange": "應用程式 - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "應用程式 - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "應用程式 - 系統狀態",
    "wr-dashboard.side-bar.backup-type.application": "應用程式",
    "wr-dashboard.backups-table.column.name": "名稱",
    "wr-dashboard.backups-table.column.size": "大小",
    "wr-dashboard.backups-table.column.version": "最後版本",
    "wr-dashboard.backups-table.action.delete": "刪除",
    "wr-dashboard.backups-table.message.no-backups": "雲端中尚無備份",
    "wr-dashboard.backups-sidebar.label.size": "大小",
    "wr-dashboard.backups-sidebar.label.type": "類型",
    "wr-dashboard.backups-sidebar.label.version": "最後版本",
    "wr-dashboard.backups-sidebar.label.created": "建立時間",
    "wr-dashboard.backups-sidebar.label.machine": "電腦",
    "wr-dashboard.backups-sidebar.label.owner": "擁有者",
    "wr-dashboard.content-table.column.name": "名稱",
    "wr-dashboard.content-table.column.versions": "版本",
    "wr-dashboard.content-table.column.volumes": "磁碟區",
    "wr-dashboard.content-table.column.path": "路徑",
    "wr-dashboard.content-table.column.size": "大小",
    "wr-dashboard.content-table.column.version": "最後版本",
    "wr-dashboard.content-table.action.notary-verify": "驗證",
    "wr-dashboard.content-table.action.notary-get-crt": "取得憑證",
    "wr-dashboard.content-table.action.asign": "傳送以供簽章",
    "wr-dashboard.content-table.action.versions": "版本",
    "wr-dashboard.content-table.action.restore": "下載",
    "wr-dashboard.content-table.label.size": "大小",
    "wr-dashboard.content-table.label.created": "建立時間",
    "wr-dashboard.content-table.label.modified": "修改時間",
    "wr-dashboard.content-table.message.empty-folder": "此資料夾是空的",
    "wr-dashboard.password-dialog-box.title.backup": "加密備份",
    "wr-dashboard.password-dialog-box.title.archive": "加密存檔",
    "wr-dashboard.password-dialog-box.message.backup": "請指定存取備份 {displayName} 的密碼",
    "wr-dashboard.password-dialog-box.message.archive": "請指定存取存檔 {displayName} 的密碼",
    "wr-dashboard.password-dialog-box.hint.password": "密碼",
    "wr-dashboard.password-dialog-box.message.invalid-password": "密碼不正確",
    "wr-dashboard.form.button.open": "開啟",
    "wr-dashboard.form.button.close": "關閉",
    "wr-dashboard.form.button.cancel": "取消",
    "wr-dashboard.form.button.continue": "繼續",
    "wr-dashboard.form.button.proceed": "繼續",
    "wr-dashboard.form.button.delete": "刪除",
    "wr-dashboard.form.button.done": "完成",
    "wr-dashboard.form.button.retry": "重試",
    "wr-dashboard.notary.verify.view.status.downloading": "正在下載...",
    "wr-dashboard.notary.verify.view.status.validating": "正在驗證...",
    "wr-dashboard.notary.verify.view.status.pending": "正在等候憑證...",
    "wr-dashboard.notary.verify.view.status.fail": "憑證不相符...",
    "wr-dashboard.notary.verify.view.button.get-crt": "取得憑證",
    "wr-dashboard.notary.verify.view.file-info.name": "名稱",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "簽署者",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "備份日期",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "公證日期",
    "wr-dashboard.notary.verify.view.button.cancel": "取消",
    "wr-dashboard.notary.verify.view.button.done": "完成",
    "wr-dashboard.notary.warning.unsupported.browser.version": "不支援的瀏覽器版本",
    "wr-dashboard.versions-dialog-box.title": "{fileName} 的版本",
    "wr-dashboard.asign-dialog-box.title": "傳送以供簽章",
    "wr-dashboard.asign-dialog-box.message": "檔案版本已共用，但是如果沒有檔案的連結，就無法檢視該檔案。繼續進行 ASign 以加入簽章並分享連結。",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "顯示檔案詳細資料",
    "wr-dashboard.page-not-found.title": "找不到頁面",
    "wr-dashboard.page-not-found.message.main": "找不到您要尋找的頁面。",
    "wr-dashboard.page-not-found.message.description": "此連結可能過時，或者您可以輸入錯誤的位址。",
    "wr-dashboard.page-not-found.message.error": "錯誤碼:404",
    "wr-dashboard.server-error.title": "伺服器無法使用",
    "wr-dashboard.server-error.message": "伺服器目前無法使用。請稍候再試。",
    "wr-dashboard.server-error.message.error": "錯誤碼:500",
    "wr-dashboard.account-menu.action.sign-out": "登出",
    "wr-dashboard.breadcrumb.item.machines": "電腦",
    "wr-dashboard.breadcrumb.item.failed-backups": "失敗的備份",
    "wr-dashboard.machines-table.column.name": "名稱",
    "wr-dashboard.machines-table.column.size": "大小",
    "wr-dashboard.machines-table.message.no-machines": "雲端中尚無電腦",
    "wr-dashboard.incomplete-backups.message.status:plural": "您有 {count} 個失敗或不完整的備份，佔用 {size} 的儲存空間 | 您有 {count} 個失敗或不完整的備份，佔用 {size} 的儲存空間",
    "wr-dashboard.incomplete-backups.button.view": "檢視備份",
    "wr-dashboard.incomplete-backups.button.delete": "刪除備份",
    "wr-dashboard.machines-table.message.space-used:plural": "備份使用量總計 {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "刪除存檔",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "刪除不完整的存檔",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "刪除所有不完整的存檔",
    "wr-dashboard.delete-archive.message": "確定要從所有位置永久刪除選取的存檔？所有資料都將遭到刪除，而且無法還原。",
    "wr-dashboard.delete-archive.deletion-warning-message": "如果保護主控台的個別工作負載不在線上，也沒有任何代理程式在線上處理變更，則在此 Web Restore 主控台中進行的任何變更在視覺上可能不會反映在該工作負載中",
    "wr-dashboard.delete-archive.locked-error-message": "已鎖定存檔，以確保資料一致性。請使用存檔終止所有作業 (例如瀏覽、還原、備份) 並再試一次。",
    "wr-dashboard.certificate-pending-dialog-box.title": "憑證等候中",
    "wr-dashboard.certificate-pending-dialog-box.message": "請在幾分鐘後重試。",
    "wr-dashboard.form.button.ok": "確定"
};
